import { getCurrentUserHasCore } from '@wix/da-shared-react/pkg/publicSession';
import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { actions as ModalActions } from '@wix/da-shared-react/pkg/Modals';
import { BIEventData } from '@wix/da-shared-react/pkg/biLogger';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import { AppState } from '../../../../types/store';
import { getInstallableModulesInfo } from '../../../selectors/layout';
import { Props } from './AddWidget';

type StateProps = Pick<Props, 'hasCoreMembership' | 'installableModulesInfo'>;
type DispatchProps = Pick<Props, 'pushBecomeCorePopup'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  props
) => ({
  hasCoreMembership: getCurrentUserHasCore(state),
  installableModulesInfo: props.installableModules.map(
    ({ moduleName, zone }) => {
      const m = getInstallableModulesInfo(state, props.section, zone) || [];
      return m.find(module => module.moduleName === moduleName);
    }
  ),
});

const mapDispatchToProps: MapDispatchToProps<
  DispatchProps,
  OwnProps
> = dispatch => ({
  pushBecomeCorePopup: (referral_info?: BIEventData['referral_info']) =>
    dispatch(
      ModalActions.pushModal(ModalType.BECOME_CORE, {
        wrapInPopup: false,
        params: {
          referral_info,
        },
      })
    ),
});

export default connect(mapStateToProps, mapDispatchToProps);
